import { render, staticRenderFns } from "./AppleGooglePay.vue?vue&type=template&id=9c58b1b6&scoped=true&"
import script from "./AppleGooglePay.vue?vue&type=script&lang=ts&"
export * from "./AppleGooglePay.vue?vue&type=script&lang=ts&"
import style0 from "./AppleGooglePay.vue?vue&type=style&index=0&id=9c58b1b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c58b1b6",
  null
  
)

export default component.exports